import { nextTick, ref, watch } from 'vue';
import { formatNumber } from '@template/utils';
/**
 * 금액 인풋 포맷터
 * - 내부 값은 number로 유지
 * - 화면에는 소수점 2자리 + 천단위 콤마로 표시
 * - 포커스 중에는 사용자가 입력한 값 그대로 유지
 */
export const useAmountInputFormatter = (options) => {
    const { amountRef, onManualChange } = options;
    const inputValue = ref('');
    const isFocused = ref(false);
    const isProgrammaticChange = ref(false);
    // 내부 값 변경 시, 포커스가 아닐 때 포맷팅 반영
    watch(amountRef, (amount) => {
        if (isFocused.value)
            return;
        isProgrammaticChange.value = true;
        inputValue.value =
            amount > 0
                ? formatNumber(amount, 'ko-KR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })
                : '';
        nextTick(() => {
            isProgrammaticChange.value = false;
        });
    }, { immediate: true });
    // 인풋 변경 시 내부 값 갱신
    watch(inputValue, (value) => {
        if (isProgrammaticChange.value)
            return;
        const normalized = value.replace(/,/g, '');
        const parsed = parseFloat(normalized);
        amountRef.value = Number.isNaN(parsed) ? 0 : parsed;
        if (onManualChange) {
            onManualChange();
        }
    });
    const handleFocus = () => {
        isFocused.value = true;
    };
    const handleBlur = () => {
        isFocused.value = false;
        // 블러 시 최종 포맷팅
        isProgrammaticChange.value = true;
        inputValue.value =
            amountRef.value > 0
                ? formatNumber(amountRef.value, 'ko-KR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })
                : '';
        nextTick(() => {
            isProgrammaticChange.value = false;
        });
    };
    return {
        inputValue,
        handleFocus,
        handleBlur,
    };
};
/**
 * 고정 금액 버튼 동작
 * - 다른 버튼을 누르면 해당 값으로 설정
 * - 같은 버튼을 연속으로 누르면 누적
 */
export const useFixedAmountButtons = (amountRef) => {
    const lastClickedAmount = ref(null);
    const handleFixedAmountClick = (amount) => {
        if (lastClickedAmount.value === null || lastClickedAmount.value !== amount) {
            amountRef.value = amount;
            lastClickedAmount.value = amount;
            return;
        }
        amountRef.value += amount;
    };
    const resetFixedAmountState = () => {
        lastClickedAmount.value = null;
    };
    return {
        handleFixedAmountClick,
        resetFixedAmountState,
    };
};
//# sourceMappingURL=amount.js.map